import { useState, useCallback, useEffect } from 'react';

import { scrollIfNeeded, timeReg, getTime24HoursFormat } from './utils';

const generateNumberArray = (n) => [...Array(n).keys()].map((i) => i + 1);
const formatNumberArray = (arr) =>
  arr.map((n) => n.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }));

export function useTimePicker(props) {
  const { onChange } = props;
  const [pickerValue, setPickerValue] = useState({});
  const [showPicker, setShowPicker] = useState(false);

  const hoursCollection = formatNumberArray(generateNumberArray(12));
  const minutesCollection = ['00', ...formatNumberArray(generateNumberArray(59))];
  const AMPMoptionsCollection = ['AM', 'PM'];

  const handleItemClick = (event) => {
    const name = event.target.getAttribute('data-name');
    const value = event.target.getAttribute('data-value');
    setPickerValue((prevProps) => ({ ...prevProps, [name]: value }));
  };

  const formatedPickerValue = useCallback(() => {
    if (pickerValue?.hours && pickerValue?.minutes && pickerValue?.ampm) {
      const hours24Format = getTime24HoursFormat(pickerValue?.hours, pickerValue?.ampm);
      const fullTime = `${pickerValue?.hours}:${pickerValue?.minutes}${pickerValue?.ampm} (${hours24Format}:${pickerValue?.minutes})`;
      onChange(fullTime);
    }
  }, [pickerValue, onChange]);

  const showActiveItems = useCallback(() => {
    const hoursElement = document.querySelector("[data-hours-active='true']");
    const minutesElement = document.querySelector("[data-minutes-active='true']");
    const hoursWrap = document.getElementById('hoursWrap');
    const minutesWrap = document.getElementById('minutesWrap');

    if (hoursElement) scrollIfNeeded(hoursElement, hoursWrap);
    if (minutesElement) scrollIfNeeded(minutesElement, minutesWrap);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPicker]);

  const parseValue = useCallback(() => {
    const value = props.value;
    if (!value) return;
    const [, hours, minutes, ampm] = value.split(timeReg);

    setPickerValue({ hours, minutes, ampm });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPicker]);

  const handleClear = () => {
    onChange(undefined);
    setShowPicker(false);
    setPickerValue({});
  };

  useEffect(() => {
    formatedPickerValue();
  }, [formatedPickerValue]);

  useEffect(() => {
    showActiveItems();
    parseValue();
  }, [showActiveItems, parseValue]);

  return {
    setShowPicker,
    showPicker,
    pickerValue,
    hoursCollection,
    minutesCollection,
    AMPMoptionsCollection,
    handleItemClick,
    handleClear,
  };
}
